export enum GradeType {
  NUMERIC = 'gpa',
  PERCENT = 'percentage',
  ABC = 'abc',
  HONOURS = 'honour',
  DISTINCTION = 'dist',
  EXCELLENCE = 'exc',
  OTHER = 'other',
}
